<template>
  <el-aside :width="$store.state.collapse?'100px':'250px'">
    <div :class="$store.state.collapse?'logoBox2':'logoBox1'">
      <img :class="$store.state.collapse?'logo2':'logo1'" src="../../static/images/feifanlogo.png" alt="" srcset="">
    </div>
    <el-menu
        router
        background-color="rgb(48, 65, 86)"
        text-color="#eeeeee"
        :collapse="$store.state.collapse"
        active-text-color="#ffffff">
      <template v-for="item in getAsyncRouter">
        <el-submenu :class="[nowRoute(item.path) ? 'active' : '']" v-if="item.children.length > 1" :index="item.path"
                    :key="item.path">
          <template slot="title">
            <img class="icon" :src="getIcon(item.meta.icon)" alt="" srcset="">
            <span class="title">{{ item.meta.title }}</span>
          </template>
          <el-menu-item :class="[nowRoute2(item.path + '/' + child.path) ? 'active2' : '', title]"
                        v-for="child in item.children" :key="child.path" :index="`${item.path}/${child.path}`">
            {{ child.meta.title }}
          </el-menu-item>
        </el-submenu>
        <el-menu-item :class="[nowRoute(item.path) ? 'active' : '', 'li3']"
                      :index="item.path === '/' ? `/${item.children[0].path}` : `${item.path}/${item.children[0].path}`"
                      v-else :key="item.path">
          <img class="icon" :src="getIcon(item.meta.icon)" alt="" srcset="">
          <span class="title">{{ item.meta.title }}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </el-aside>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  data() {
    return {
      routers: []
    }
  },
  computed: {
    ...mapGetters('user', ['getAsyncRouter']),
    nowRoute() {
      return (_path) => {
        const {path} = this.$route;
        if (_path === '/' && path === '/home') return true
        if (path.indexOf(_path) !== -1 && _path !== '/') {
          return true
        }
      }
    },
    nowRoute2() {
      return (_path) => {
        const {path} = this.$route;
        if (path === _path) {
          return true
        }
      }
    },
    getIcon() {
      return name => require(`../../static/images/${name}.png`)
    },
    // 样式
    title() {
      return this.$store.state.collapse ? 'title3' : 'title2'
    }
  },
  created() {
    this.routers = this.$router.options.routes.filter(item => item.path !== '/login');
  },
  methods: {
    triggerSelect() {

    },
    triggerClick() {

    }
  }
}
</script>

<style lang="less" scoped>
.logoBox1 {
  width: 125px;
  height: 125px;
  background: #FFFFFF;
  border-radius: 3px;
  margin: 39px auto 68px;
}

.logoBox2 {
  width: 80%;
  height: 75px;
  background: #FFFFFF;
  border-radius: 10px;
  margin: 20px auto;
}

.logo1 {
  width: 79px;
  height: 68px;
  margin-top: 28px;
  margin-left: 23px;
}

.logo2 {
  width: 59px;
  height: 48px;
  margin-top: 10px;
  margin-left: 10px;
  background-color: #fff;
}

.el-aside {
  background: rgb(48, 65, 86);
  color: #FFFFFF;
}

.el-menu {
  border-right: none;
}

.el-menu--collapse {
  width: 100px;
}

.title {
  font-size: 18px;
  color: #c1c1c1;
}

.title2 {
  font-size: 14px;
  padding-left: 90px !important;
  color: #c1c1c1 !important;
}

// 伸缩宽度
.title3 {
  font-size: 14px;
  text-align: center !important;
  color: #c1c1c1 !important;
}

.icon {
  width: 22px;
  margin-right: 30px;
}

/deep/ .el-submenu__title {
  padding-left: 38px !important;
}

.el-icon-arrow-right, .el-icon-arrow-down {
  color: #FFFFFF;
  font-size: 17px;
  margin: 0;
  position: absolute;
  right: 25px;
  top: 19.5px;
}

.li3 {
  padding-left: 38px !important;
}

.active {
  background: rgb(48, 65, 86) !important;
}

.active2 {
  background: rgb(0 0 0 / 26%) !important;
  color: #FFFFFF !important;
}

.active /deep/ .title {
  color: #FFFFFF;
}

/deep/ .el-submenu__title i {
  color: #FFFFFF;
}

.active /deep/ .el-submenu__title:hover {
  background: rgba(0, 0, 0, 0.26) !important;
  color: #FFFFFF !important;
}

/deep/ .el-submenu__title:hover {
  background: rgba(0, 0, 0, 0.26) !important;
  color: #FFFFFF !important;
}

/deep/ .el-menu-item:hover {
  background: rgba(0, 0, 0, 0.26) !important;
  color: #FFFFFF !important;
}

/deep/ .el-submenu__title:hover, .el-menu-item:focus, .el-menu-item:hover {
  background: rgba(0, 0, 0, 0.26) !important;
  color: #FFFFFF !important;
}

/deep/ .el-menu-item {

}
</style>